function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.2851 14.3334L8.74595 12.86M13.9996 6.33333H9.91392C9.39387 6.33333 9.13411 6.33332 8.93548 6.23644C8.76075 6.15122 8.6188 6.01527 8.52978 5.84801C8.42857 5.65787 8.42857 5.40894 8.42857 4.91111V1M14 14.1556V6.91466C14 6.50265 14.0002 6.29664 13.9538 6.10162C13.9126 5.92867 13.8448 5.76256 13.7522 5.60888C13.6479 5.43558 13.5016 5.28442 13.2092 4.9821L10.2395 1.91189C9.91447 1.5759 9.75182 1.40789 9.55845 1.28749C9.38706 1.18077 9.19803 1.1019 8.99978 1.05402C8.77612 1 8.53741 1 8.05906 1H3.97161C2.93151 1 2.41108 1 2.01381 1.19377C1.66437 1.36421 1.38047 1.63619 1.20242 1.9707C1 2.35099 1 2.84881 1 3.84446V14.1556C1 15.1512 1 15.649 1.20242 16.0293C1.38047 16.3638 1.66437 16.6358 2.01381 16.8062C2.41108 17 2.93151 17 3.97161 17H11.0288C12.0689 17 12.5885 17 12.9858 16.8062C13.3352 16.6358 13.6197 16.3638 13.7978 16.0293C14.0002 15.649 14 15.1512 14 14.1556ZM7.03571 13.4444C5.75362 13.4444 4.71429 12.4495 4.71429 11.2222C4.71429 9.99492 5.75362 9 7.03571 9C8.3178 9 9.35714 9.99492 9.35714 11.2222C9.35714 12.4495 8.3178 13.4444 7.03571 13.4444Z",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgFile = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 18",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file.83442d97.svg";
export { ForwardRef as ReactComponent };